import { plugins, request } from '@gameforge/http-client'
import { reportBreadcrump } from './reportBreadcrumb'

export const apiClient = request(`${window.origin}/api`)
  .use(reportBreadcrump)
  .use(plugins.throwOnStatus(400))
